export enum REPORT_STYLE {
    WITH_TAXES = 'T',
    WITHOUT_TAXES = 'A',
}

export type ReportStyleType =
    | REPORT_STYLE.WITH_TAXES
    | REPORT_STYLE.WITHOUT_TAXES;
